export default {
  title: 'Voorbestellen',
  categories: {
    title: 'Meest populair',
  },
  header: {
    pickup: 'Afhalen in 5 minuten',
  },
};
